"use strict";

exports.__esModule = true;
exports.AnimationStateData = void 0;

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/

/** Stores mix (crossfade) durations to be applied when {@link AnimationState} animations are changed. */
var AnimationStateData = /*#__PURE__*/function () {
  function AnimationStateData(skeletonData) {
    /** The SkeletonData to look up animations when they are specified by name. */
    this.skeletonData = null;
    this.animationToMixTime = {};
    /** The mix duration to use when no mix duration has been defined between two animations. */

    this.defaultMix = 0;
    if (!skeletonData) throw new Error("skeletonData cannot be null.");
    this.skeletonData = skeletonData;
  }
  /** Sets a mix duration by animation name.
   *
   * See {@link #setMixWith()}. */


  var _proto = AnimationStateData.prototype;

  _proto.setMix = function setMix(fromName, toName, duration) {
    var from = this.skeletonData.findAnimation(fromName);
    if (!from) throw new Error("Animation not found: " + fromName);
    var to = this.skeletonData.findAnimation(toName);
    if (!to) throw new Error("Animation not found: " + toName);
    this.setMixWith(from, to, duration);
  }
  /** Sets the mix duration when changing from the specified animation to the other.
   *
   * See {@link TrackEntry#mixDuration}. */
  ;

  _proto.setMixWith = function setMixWith(from, to, duration) {
    if (!from) throw new Error("from cannot be null.");
    if (!to) throw new Error("to cannot be null.");
    var key = from.name + "." + to.name;
    this.animationToMixTime[key] = duration;
  }
  /** Returns the mix duration to use when changing from the specified animation to the other, or the {@link #defaultMix} if
    * no mix duration has been set. */
  ;

  _proto.getMix = function getMix(from, to) {
    var key = from.name + "." + to.name;
    var value = this.animationToMixTime[key];
    return value === undefined ? this.defaultMix : value;
  };

  return AnimationStateData;
}();

exports.AnimationStateData = AnimationStateData;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFrQ0E7SUFDYUEsa0I7RUFTWiw0QkFBYUMsWUFBYixFQUF1QztJQVJ2QztJQUNBLG9CQUE2QixJQUE3QjtJQUVBLDBCQUF3QyxFQUF4QztJQUVBOztJQUNBLGtCQUFhLENBQWI7SUFHQyxJQUFJLENBQUNBLFlBQUwsRUFBbUIsTUFBTSxJQUFJQyxLQUFKLENBQVUsOEJBQVYsQ0FBTjtJQUNuQixLQUFLRCxZQUFMLEdBQW9CQSxZQUFwQjtFQUNBO0VBRUQ7Ozs7Ozs7U0FHQUUsTSxHQUFBLGdCQUFRQyxRQUFSLEVBQTBCQyxNQUExQixFQUEwQ0MsUUFBMUMsRUFBMEQ7SUFDekQsSUFBSUMsSUFBSSxHQUFHLEtBQUtOLFlBQUwsQ0FBa0JPLGFBQWxCLENBQWdDSixRQUFoQyxDQUFYO0lBQ0EsSUFBSSxDQUFDRyxJQUFMLEVBQVcsTUFBTSxJQUFJTCxLQUFKLENBQVUsMEJBQTBCRSxRQUFwQyxDQUFOO0lBQ1gsSUFBSUssRUFBRSxHQUFHLEtBQUtSLFlBQUwsQ0FBa0JPLGFBQWxCLENBQWdDSCxNQUFoQyxDQUFUO0lBQ0EsSUFBSSxDQUFDSSxFQUFMLEVBQVMsTUFBTSxJQUFJUCxLQUFKLENBQVUsMEJBQTBCRyxNQUFwQyxDQUFOO0lBQ1QsS0FBS0ssVUFBTCxDQUFnQkgsSUFBaEIsRUFBc0JFLEVBQXRCLEVBQTBCSCxRQUExQjtFQUNBO0VBRUQ7Ozs7O1NBR0FJLFUsR0FBQSxvQkFBWUgsSUFBWixFQUE2QkUsRUFBN0IsRUFBNENILFFBQTVDLEVBQTREO0lBQzNELElBQUksQ0FBQ0MsSUFBTCxFQUFXLE1BQU0sSUFBSUwsS0FBSixDQUFVLHNCQUFWLENBQU47SUFDWCxJQUFJLENBQUNPLEVBQUwsRUFBUyxNQUFNLElBQUlQLEtBQUosQ0FBVSxvQkFBVixDQUFOO0lBQ1QsSUFBSVMsR0FBRyxHQUFHSixJQUFJLENBQUNLLElBQUwsR0FBWSxHQUFaLEdBQWtCSCxFQUFFLENBQUNHLElBQS9CO0lBQ0EsS0FBS0Msa0JBQUwsQ0FBd0JGLEdBQXhCLElBQStCTCxRQUEvQjtFQUNBO0VBRUQ7Ozs7U0FFQVEsTSxHQUFBLGdCQUFRUCxJQUFSLEVBQXlCRSxFQUF6QixFQUFzQztJQUNyQyxJQUFJRSxHQUFHLEdBQUdKLElBQUksQ0FBQ0ssSUFBTCxHQUFZLEdBQVosR0FBa0JILEVBQUUsQ0FBQ0csSUFBL0I7SUFDQSxJQUFJRyxLQUFLLEdBQUcsS0FBS0Ysa0JBQUwsQ0FBd0JGLEdBQXhCLENBQVo7SUFDQSxPQUFPSSxLQUFLLEtBQUtDLFNBQVYsR0FBc0IsS0FBS0MsVUFBM0IsR0FBd0NGLEtBQS9DO0VBQ0EsQyIsIm5hbWVzIjpbIkFuaW1hdGlvblN0YXRlRGF0YSIsInNrZWxldG9uRGF0YSIsIkVycm9yIiwic2V0TWl4IiwiZnJvbU5hbWUiLCJ0b05hbWUiLCJkdXJhdGlvbiIsImZyb20iLCJmaW5kQW5pbWF0aW9uIiwidG8iLCJzZXRNaXhXaXRoIiwia2V5IiwibmFtZSIsImFuaW1hdGlvblRvTWl4VGltZSIsImdldE1peCIsInZhbHVlIiwidW5kZWZpbmVkIiwiZGVmYXVsdE1peCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvQW5pbWF0aW9uU3RhdGVEYXRhLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19